import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import { RouteComponentProps } from 'react-router-dom'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'
import SubnavBar from 'Components/Shared/SubnavBar'
import {
  TableHeader,
  TableColHeader,
  LineHeader,
} from 'Components/Shared/Table'
import Pagination from 'Components/Shared/Pagination'
import EventModal from 'Components/Shared/Modal/EventModal'
import { AlertError } from 'Components/Shared'
import Menu from '../../../MenuAdmin'
import { GetDataListReq } from 'features/admin/checklist-config/types'
import { Button, Col, Row } from 'antd'

import {
  getCheckList,
  deleteCheckList,
} from 'features/checklist/constructPlan/api'
import { updateCheckListDetail } from 'features/checklist/constructPlan/actions'

import { CheckListItem } from 'features/checklist/constructPlan/types'
import { toCheckList } from 'importer/constructPlan'
import DeleteModal, {
  DeleteModalHandles,
} from 'Components/Shared/Modal/DeleteModal'

import RowItem from './RowItem'
import { SearchInput } from 'Components/Filter'
import DropdownList from 'Components/Shared/Form/DropdownList'
import { onGetChecklistTypeConfigList } from 'features/admin/checklist-config/api'
import { selectDataList } from 'features/admin/checklist-config/selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'
const breadcrumbs: BreadcrumbLink[] = [
  {
    url: '/dashboard',
    title: 'Home',
    icon: '/home.png',
    active: true,
    showTitle: false,
  },
  {
    url: '/check-construct-plan',
    title: 'ตรวจงาน Site visit ระหว่างก่อสร้าง',
    active: false,
    showTitle: false,
  },
]

type Props = ReduxProps & DispatchProps & RouteComponentProps

const CheckUnitList: React.ComponentType<Props> = ({
  checkList,
  event,
  history,
  UserEmail,
  token,
  checklistConfigList,
}) => {
  const modalRef = useRef<DeleteModalHandles>(null)
  const deleteItem = useRef<CheckListItem | null>(null)
  const [enableModal, setEnableModal] = useState(false)
  const [searchText, setSearchText] = useState('')
  const [checklistTypeID, setChecklistTypeID] = useState(0)
  const [err, setErr] = useState(undefined)
  const [pagination, setPagination] = useState<{
    Page: number
    RowPerPage: number
  }>({
    Page: 1,
    RowPerPage: 10,
  })
  const [checklistTypeDropdown, setChecklistTypeDropdown] = useState([
    {
      name: 'ทั้งหมด',
      value: 0,
    },
  ] as any[])
  const dispatch = useDispatch()

  useEffect(() => {
    onGetList()
    onGetListChecklistType()
  }, [pagination])

  useEffect(() => {
    checklistConfigList.List.sort((a, b) => a.Sequence - b.Sequence)
      .filter(item => item.ID !== undefined && item.IsActive === 'A')
      .map(item =>
        checklistTypeDropdown.push({
          name: item.ChecklistName,
          value: item.ID!,
        })
      )
  }, [checklistConfigList])

  const onGetList = () => {
    dispatch(
      getCheckList(
        pagination.Page,
        pagination.RowPerPage,
        searchText,
        checklistTypeID
      )
    )
  }
  const onGetListChecklistType = () => {
    setChecklistTypeDropdown([
      {
        name: 'ทั้งหมด',
        value: 0,
      },
    ])
    const req: GetDataListReq = {
      UserEmail,
      Page: 1,
      RowPerPage: 100,
    }
    dispatch(onGetChecklistTypeConfigList(token, req))
  }

  const onRefreshPage = () => {
    setEnableModal(false)
    onGetList()
  }

  const onDelete = async () => {
    if (deleteItem.current) {
      setEnableModal(true)
      dispatch(deleteCheckList(deleteItem.current.CheckListID))
    }
  }

  const showDeleteModal = (item: CheckListItem) => {
    if (modalRef.current) {
      modalRef.current.showModal('คุณยืนยันต้องการลบ checklist นี้', 0)
      deleteItem.current = item
    }
  }

  const closeEnableModal = () => setEnableModal(false)

  const onImportFile = (data: any) => {
    try {
      const checklist = toCheckList(data)
      dispatch(updateCheckListDetail(checklist))
      history.push('/check-construct-plan/create')
    } catch (e) {
      console.log('import err:', e.message)
      setErr(e.message)
    }
  }

  const content = checkList.List.map((item: any, index: number) => {
    return <RowItem key={index} item={item} showDeleteModal={showDeleteModal} />
  })

  const onSearch = (val: string) => {
    if (searchText === '' && val === '') return
    setSearchText(val)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  return (
    <>
      <SubnavBar
        breadcrumbs={breadcrumbs}
        hideSearch={true}
        adminSearchBox={<SearchInput onSearch={onSearch} />}
      />
      <EventModal
        event={[event]}
        enable={enableModal}
        successCalback={onRefreshPage}
        errorCalback={closeEnableModal}
      />
      <AlertError
        isShow={err !== undefined}
        text={err}
        callback={() => setErr(undefined)}
      />
      <Menu selected="check-construct-plan">
        <MainPage>
          <LineHeader
            title="ตรวจงาน Site visit ระหว่างก่อสร้าง"
            textImport="นำเข้า Checklist"
            textCreate="สร้าง Checklist ใหม่"
            onCreate={() => {
              history.push('/check-construct-plan/create')
            }}
            onImport={onImportFile}
          />{' '}
          <Row>
            <Col span={6}>
              <Box>
                <DropdownList
                  label="ประเภท Checklist"
                  value={checklistTypeID}
                  placeholder="เลือก"
                  menu={checklistTypeDropdown}
                  onChange={(value: any) => {
                    setChecklistTypeID(value)
                  }}
                />
              </Box>
            </Col>
            <Col span={6}>
              <Button type="primary" onClick={() => onGetList()}>
                กรองข้อมูล
              </Button>
            </Col>
          </Row>
          <TableHeader>
            <TableColHeader span={6} isPadding={true}>
              Checklist name
            </TableColHeader>
            <TableColHeader span={3}>ประเภท Checklist</TableColHeader>
            <TableColHeader span={3}>ประเภทโครงการ</TableColHeader>
            <TableColHeader span={3}>จำนวนโครงการที่ใช้งาน</TableColHeader>
            <TableColHeader span={2}>วันที่สร้าง</TableColHeader>
            <TableColHeader span={4}>แก้ไขล่าสุด</TableColHeader>
            <TableColHeader span={2} offset={1} sort={false}>
              Action
            </TableColHeader>
          </TableHeader>
          {content}
          <Pagination
            currentPage={pagination.Page}
            totalRows={checkList.Total}
            perPage={pagination.RowPerPage}
            onChangeNumber={(row: number) => {
              pagination.RowPerPage = row
              setPagination({ ...pagination })
            }}
            onClickPage={(page: number) => {
              pagination.Page = page
              setPagination({ ...pagination })
            }}
          />
        </MainPage>
      </Menu>
      <DeleteModal ref={modalRef} onOk={onDelete} />
    </>
  )
}

const MainPage = styled.div`
  padding: 40px 45px;
  width: 100%;
`
const Box = styled.div`
  padding: 0 12px 12px 0;
`
const mapStateToProps = (state: RootState) => {
  return {
    checkList: state.planChecklist.CheckList,
    event: state.planChecklist.Event,
    checklistConfigList: selectDataList(state),
    token: serviceTokenSelector(state),
    UserEmail: userEmailSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>
const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CheckUnitList)
